const privacyActStates = new Set(['CA', 'CO', 'CT']);

export default function shouldShowPrivacyAct(stateList) {
  if (stateList?.some((item) => privacyActStates.has(item.state))) {
    return true;
  }
  return false;
}
